import { createApiSlice } from "@common/common-slice/commonSlice";

import { CRUD_ASSESSMENT_METHOD } from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addAssessmentMethod",
    method: "post",
    url: CRUD_ASSESSMENT_METHOD,
    stateKey: "message",
  },
  {
    name: "updateAssessmentMethod",
    method: "put",
    url: CRUD_ASSESSMENT_METHOD,
    stateKey: "message",
  },
  {
    name: "deleteAssessmentMethod",
    method: "delete",
    url: CRUD_ASSESSMENT_METHOD,
    stateKey: "message",
  },
  {
    name: "getAssessmentMethod",
    method: "get",
    url: CRUD_ASSESSMENT_METHOD,
    stateKey: "data",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    details: [],
    AssessmentMethodSelectedData: null,
  },
  reducers: {
  },
  // extraReducers: {
  //   // Example of custom extra reducer
  //   someCustomAction: (state, action) => {
  //     // Custom reducer logic
  //   },
  // },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "AssessmentMethod",
  apiConfig,
  customReducers
);
const AssessmentMethodSlice = slice;
// Export the slice's reducer
export default AssessmentMethodSlice.reducer;

// Dynamically export all actions
export const actionsExports = actions;

// Destructure and export thunks directly from thunksExports
export const {
  addAssessmentMethod,
  updateAssessmentMethod,
  deleteAssessmentMethod,
  getAssessmentMethod,
} = thunks;